import styled from "styled-components";
import InLineButton from "../elements/InLineEditButtonStyled";

const InLineEditButtonConfirmStyled = styled(InLineButton)`
  background-color: ${(props) => props.theme.primarybuttonbackgroundcolor};
  padding-bottom: 5px;
`;

export default InLineEditButtonConfirmStyled;
